import React from 'react'

const NotifyPlayersCheckbox = React.forwardRef((props, ref) => (
  <div className='row'>
    <div className='col-sm-10 text-center shifted-field'>
      <label className='game-form-notify-checkbox'>
        <input type='checkbox' {...props} ref={ref} />
        <div className='notify-text'>{props.label}</div>
      </label>
    </div>
  </div>
))

export default NotifyPlayersCheckbox
